import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6e4e3d82"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "popup-completed-contain"
}
const _hoisted_2 = { class: "popup-completed-contain-inner" }
const _hoisted_3 = { class: "completed-box" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "completed-content" }
const _hoisted_6 = ["src"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "completed-title" }, "ยินดีด้วย", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "completed-description" }, [
  /*#__PURE__*/_createTextVNode(" คุณได้ไพ่ Golden Card"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" มีดวงได้รับของรางวัลในสัปดาห์นี้"),
  /*#__PURE__*/_createElementVNode("br")
], -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "completed-description2" }, " อย่าลืมกรอกข้อมูลเพื่อลุ้นรับรางวัล ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ButtonGold = _resolveComponent("ButtonGold")!
  const _component_router_link = _resolveComponent("router-link")!

  return (!_ctx.isClosed)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", {
              class: "completed-close-btn",
              onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleClose && _ctx.handleClose(...args)), ["prevent"]))
            }, [
              _createElementVNode("img", {
                src: `${require('@/assets/images/home/close.svg')}`,
                alt: ""
              }, null, 8, _hoisted_4)
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("img", {
                class: "completed-icon",
                src: `${require('@/assets/images/form/icon-completed.svg')}`,
                alt: ""
              }, null, 8, _hoisted_6),
              _hoisted_7,
              _hoisted_8,
              _hoisted_9,
              _createVNode(_component_router_link, { to: "/form" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ButtonGold, { "button-data": { name: 'กรอกข้อมูลเลย', width: '144px' } })
                ]),
                _: 1
              })
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}